export default __webpack_public_path__ + "static/media/app-logo-teltow-flaeming.6bcc624f.png";